import {
  ApiServiceSettingsApi,
  useAuthenticatedAPIConfig,
  useFormSubmit,
} from "melco-shared-logic";
import { BasicSettingsFormValueType } from "./useBasicSettingsFormSubmit";

export const useApiServiceBasicSettingsFormSubmit = () => {
  const authenticatedApiConfig = useAuthenticatedAPIConfig();

  const onSubmit = useFormSubmit<BasicSettingsFormValueType>(
    async (values: BasicSettingsFormValueType, { resetForm }) => {
      const { default_embroidery_production_file_format, measurement_unit } =
        values;

      const api = new ApiServiceSettingsApi(authenticatedApiConfig());

      await api.accountProductSettingsEditApiServiceAppSetting({
        apiserviceMelcoFusionModelsFusionAppSetting: {
          default_embroidery_production_file_format:
            default_embroidery_production_file_format,
          measurement_unit,
          enable_production_links: false,
        },
      });

      resetForm({ values });

      return { successMessages: [{ message: "default" }] };
    },
    { translationPrefix: "settings.basic" }
  );

  return onSubmit;
};
